import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import { ProfileActionsWidgetItem } from '../ProfileActionsWidgetItem'
import { useProfileWidgetsExpandContext } from '../Widget.hooks'

import {
  PROFILE_ACTIONS_WIDGET_EXPAND_ALL_BUTTON_ICON,
  PROFILE_ACTIONS_WIDGET_EXPAND_ALL_BUTTON_TOOLTIP_KEY,
  ProfileActionsWidgetExpandAllButtonAction,
} from './ProfileActionsWidgetExpandAllButton.constants'

function ProfileActionsWidgetExpandAllButton({
  Component = ProfileActionsWidgetItem,
}) {
  const { t } = useTranslation()

  const widgetsExpand = useProfileWidgetsExpandContext()

  const { handleToggleAll, hasCountedWidgets, isAllCollapsed } =
    widgetsExpand ?? EMPTY_OBJECT

  const action = isAllCollapsed
    ? ProfileActionsWidgetExpandAllButtonAction.expand
    : ProfileActionsWidgetExpandAllButtonAction.collapse

  return widgetsExpand ? (
    <Component
      beforeIconProps={{
        Icon: PROFILE_ACTIONS_WIDGET_EXPAND_ALL_BUTTON_ICON[action],
      }}
      disabled={!hasCountedWidgets}
      qaName={action}
      tooltip={t(PROFILE_ACTIONS_WIDGET_EXPAND_ALL_BUTTON_TOOLTIP_KEY[action])}
      value={action}
      onClick={handleToggleAll}
    />
  ) : null
}

export default ProfileActionsWidgetExpandAllButton
